// src/resources/Vehicles/VehicleBulkUpload.js

import React from "react";
import * as XLSX from "xlsx";
import { collection, addDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function VehicleBulkUpload() {

  // 🔹 Excel Date Parser (fix 1970 issue)
  const parseExcelDate = (value) => {
    if (!value) return null;

    // If value is already a JS Date
    if (value instanceof Date && !isNaN(value)) return value;

    // Excel serial number → convert to JS Date
    if (typeof value === "number") {
      const excelEpoch = new Date(1899, 11, 30); // Excel start date
      const parsed = new Date(excelEpoch.getTime() + value * 86400 * 1000);
      return parsed;
    }

    // If value is a string date (DD/MM/YYYY or YYYY-MM-DD)
    if (typeof value === "string") {
      const parts = value.split(/[-/]/);
      if (parts.length === 3) {
        let d = Number(parts[0]);
        let m = Number(parts[1]) - 1;
        let y = Number(parts[2]);

        // Convert 2-digit year → 202x
        if (y < 100) y = y + 2000;

        const parsed = new Date(y, m, d);
        if (!isNaN(parsed)) return parsed;
      }
    }

    return null;
  };

  const handleBulkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet);

      if (!rows.length) {
        alert("❌ Excel sheet is empty!");
        return;
      }

      // Fetch companies
      const snap = await getDocs(collection(db, "companies"));
      const existingCompanies = snap.docs.map((d) => d.data().name);

      // Validate companies
      const missingCompanies = new Set();
      rows.forEach((r) => {
        const name = (r.company || "").trim();
        if (!existingCompanies.includes(name)) {
          missingCompanies.add(name || "[EMPTY]");
        }
      });

      if (missingCompanies.size > 0) {
        alert(
          "❌ These company names do not exist:\n\n" +
            Array.from(missingCompanies).join("\n") +
            "\n\nAdd them in Companies section first."
        );
        return;
      }

      if (!window.confirm(`Upload ${rows.length} vehicles?`)) return;

      for (const r of rows) {
        await addDoc(collection(db, "vehicles"), {
          vehicleNumber: r.vehicleNumber || "",
          vehicleType: r.vehicleType || "",
          vehicleYear: r.vehicleYear || "",
          company: r.company,

          // FIXED: Proper date parsing
          insuranceExpiry: parseExcelDate(r.insuranceExpiry),
          registrationExpiry: parseExcelDate(r.registrationExpiry),
          installmentStart: parseExcelDate(r.installmentStart),
          installmentEnd: parseExcelDate(r.installmentEnd),
          manualRevisedEndDate: parseExcelDate(r.manualRevisedEndDate),
          settlementDate: parseExcelDate(r.settlementDate),

          mortgageFrom: r.mortgageFrom || "",
          installmentBank: r.installmentBank || "",
          totalFacilityAmount: Number(r.totalFacilityAmount) || 0,
          monthlyInstallment: Number(r.monthlyInstallment) || 0,
          bankCharges: Number(r.bankCharges) || 0,
          settlementAmount: Number(r.settlementAmount) || 0,
          settlementNotes: r.settlementNotes || "",
          deferredInstallments: [],

          remainingFinance: 0, // your UI calculates later

          // No file uploads in bulk mode
          insuranceFile: null,
          registrationFile: null,
          financeFile: null,

          status: r.status || "Active",
          createdAt: serverTimestamp(),
          createdBy: localStorage.getItem("email") || "",
        });
      }

      alert("🎉 Bulk vehicle upload completed successfully!");
      window.location.reload();

    } catch (err) {
      alert("❌ Bulk upload failed: " + err.message);
      console.error(err);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 15 }}>
      <label
        style={{
          background: "#1976d2",
          color: "white",
          padding: "7px 12px",
          borderRadius: 6,
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Bulk Upload Vehicles (.xlsx)
        <input
          type="file"
          accept=".xlsx"
          style={{ display: "none" }}
          onChange={handleBulkUpload}
        />
      </label>
    </div>
  );
}
